import React, { useContext, useState } from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";

import Plano from "./Plano";
import ModalPlanoM from "./ModalPlanoM";
import ModalPlano from "./ModalPlano";
import DeleteButton from "./DeleteButton";

import { PlanContext } from "../context/Plancontext";

export default function EditPlano() {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const { plans, insertPlanLoading, deleteLoading, deletePlan } =
    useContext(PlanContext);

  const handleDelete = async (id) => {
    await deletePlan(id);
  };

  return (
    <div className={classes.root}>
      <div
        className={classes.addplan}
        onClick={() => setExpanded((v) => !v)}
        role="button"
        tabIndex={0}
      >
        <Typography className={classes.planoD}>Planos</Typography>
        {expanded ? <ModalPlano /> : null}
      </div>
      <div
        className={classes.addplanM}
        onClick={() => setExpanded((v) => !v)}
        role="button"
        tabIndex={0}
      >
        <Typography className={classes.planoM}>Planos</Typography>
        {expanded ? <ModalPlanoM /> : null}
      </div>
      {expanded && !insertPlanLoading && !deleteLoading ? (
        <Grid container className={classes.container} spacing={2}>
          {plans?.map((plan) => (
            <Grid key={plan.id} item xs={12} sm={6} md={4}>
              <div className={classes.item}>
                <Plano data={plan} />
                <div className={classes.editbuttons}>
                  <div className={classes.desktop}>
                    <ModalPlano id={plan.id} data={plan} />
                  </div>
                  <div className={classes.mobile}>
                    <ModalPlanoM id={plan.id} data={plan} />
                  </div>
                  <DeleteButton id={plan.id} onDelete={handleDelete} />
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        expanded ? <div style={{ fontSize: 20, margin: 40 }}>Carregando...</div> : null
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
  },
  addplan: {
    marginTop: "28px",
    width: "100%",
    height: "70px",
    backgroundColor: theme.colors.darkBlue,
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "40px",
    paddingRight: "20px",
    display: "flex",
    cursor: 'pointer',
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  addplanM: {
    marginTop: "24px",
    width: "100%",
    height: "45px",
    backgroundColor: theme.colors.darkBlue,
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "flex",
    cursor: 'pointer',
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  addimg: {
    height: "21px",
  },
  addbutton: {
    maxWidth: "21px",
  },
  planoD: {
    font: "Karla",
    fontSize: "32px",
    color: theme.colors.white,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  planoM: {
    font: "Karla",
    fontSize: "20px",
    color: theme.colors.white,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  item: {
    height: "100%",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  editbuttons: {
    marginTop: "11px",
    width: "100%",
    justifyContent: "center",
    gap: "24px",
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
  },
  editbuttom: {
    height: "24px",
    width: "24px",
  },
  container: {
    marginTop: "28px",
    width: "100%",
    alignItems: "center",
    display: "flex",
  },
  desktop: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobile: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));
